var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',{attrs:{"transform":"scale(1.4)","id":"gmain"}},_vm._l((_vm.tooths),function(i){return _c('Tooth',{key:i,attrs:{"number":i,"positionY":_vm.y,"positionX":Math.abs((i - _vm.start ) * 32) + _vm.x}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }